/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DataExcel.vue?vue&type=template&id=592e3b1c&scoped=true&"
import script from "./DataExcel.vue?vue&type=script&lang=js&"
export * from "./DataExcel.vue?vue&type=script&lang=js&"
import style0 from "./DataExcel.vue?vue&type=style&index=0&id=592e3b1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592e3b1c",
  null
  
)

export default component.exports